/*  eslint-disable no-param-reassign */
angular.module('resyApp')
  .component('resyEmailVerified', {
    templateUrl: 'components/auth/components/email-verified/email-verified.html',
    controller: ResyEmailVerifiedController,
    controllerAs: 'vm',
  });

function ResyEmailVerifiedController($rootScope) {
  $rootScope.metadata.bodyClasses = 'page-email-verified';
}

export default () => {};
